import { render, staticRenderFns } from "./addMediaListTable.vue?vue&type=template&id=c5a4b8e4&scoped=true&"
import script from "./addMediaListTable.vue?vue&type=script&lang=js&"
export * from "./addMediaListTable.vue?vue&type=script&lang=js&"
import style0 from "./addMediaListTable.vue?vue&type=style&index=0&id=c5a4b8e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a4b8e4",
  null
  
)

export default component.exports